<script lang="ts">
	//Svelte hooks
	import { beforeUpdate } from 'svelte';
	//Helpers
	import {
		get_mode,
		is_dali,
		is_gen_2,
		is_gen_z,
		isBluTRV,
		isGen2EM,
		isEMWithoutSwitch,
		isWallDisplay,
		real_id,
		is_loqed,
		isDiffuser,
		isPill,
		isCameraDevice,
		isActuator as isActuatorHelper,
		isNoRelayPlug,
		isFanDevice,
	} from '../../../../../../helpers/interface_helpers';
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { isPeripheralDevice } from 'src/helpers/addons/addon_device_helpers';
	import { checkDeviceForceUpdate } from 'src/helpers/firmware_helpers';

	//Configs
	import { devices_config } from '@devices/index';
	//Stores
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { updating_devices } from 'src/stores/device-runtime/process';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Components
	import ControlOnOff from 'src/components/Controls/Single/ControlOnOff.svelte';
	import ControlDirection from 'src/components/Controls/Single/ControlDirection.svelte';
	import ControlTrv from 'src/components/Controls/Single/ControlTrv.svelte';
	import InputsReaderVisualizer from 'src/components/Controls/Indicators/InputsReaderVisualizer.svelte';
	import ControlOnOffAddon from 'src/components/Controls/Single/ControlOnOffAddon.svelte';
	import ControlDirectionG2 from 'src/components/Controls/Single/ControlDirectionG2.svelte';
	import ControlOnOffZ from 'src/components/Controls/Single/ControlOnOffZ.svelte';
	import ControlLock from 'src/components/Controls/Single/ControlLock.svelte';
	import ControlDirectionZ from 'src/components/Controls/Single/ControlDirectionZ.svelte';
	import TemplatesControl from 'src/components/XT1/TemplatesControl.svelte';
	import BluTrvControl from 'src/components/DevicesSettings/VirtualComponents/BluTRV/BluTrvControl.svelte';
	import AuthenticateDevice from 'src/components/Devices/DeviceWizard/AuthenticateDevice.svelte';
	import ControlWallDisplayThermostat from 'src/components/Controls/Single/ControlWallDisplayThermostat.svelte';
	import RadarControl from 'src/components/Controls/Single/RadarControl.svelte';
	import ControlOnOffDiffuser from 'src/components/Controls/Single/ControlOnOffDiffuser.svelte';
	import ControlVentoraBoost from 'src/components/Controls/Single/ControlVentoraBoost.svelte';
	import PillControlStatusSlot from 'src/components/ThePill/PillControlStatusSlot.svelte';
	import VirtualDeviceControl from 'src/components/DevicesSettings/VirtualComponents/VirtualDeviceControl.svelte';
	import CameraStatusLabel from 'src/components/Camera/SidepanelLayout/CameraStatusLabel.svelte';
	//Design system components
	import { LabelV2, Loader, Icon, CircularProgress } from '@Shelly/shelly-design-system';
	import { devices_config_wave } from 'src/devices_config_wave';
	import type { FormattedItemType } from 'src/components/DevicesSettings/CustomizeDeviceWizard/customize-device-wizard-helpers';
	import { checkIsCriticalEvent } from 'src/helpers/device_data_helpers';
	import { isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
	import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
	import { isProSensorAddon } from 'src/helpers/addons/addon_support_helpers';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';

	export let device, status, settings, statuses;
	export let type = '';
	export let isLoading = false;
	export let notAuthenticated = false; //this is for wall display authentication
	export let isCondensed = false;
	export let inPreivew = false;
	export let useV2Components = false;
	export let cardHandlesOnOff = false;
	/** Status is already shown on a camera cover card header. */
	export let suppressCameraStatusLabel = false;
	// extract main status

	let mainParamElement = null;
	$: deviceState = getDeviceState(device?.channel >= 100 ? device?.id : real_id(device?.id)) as any;
	$: isLoading = $deviceState?.isLoading;
	$: icon = $deviceState?.icon;
	$: iconColor = $deviceState?.iconColor;
	$: isUpdating = $deviceState?.type === 3;
	$: fwUpdateProgress =
		$updating_devices?.[device?.id]?.prog === undefined
			? 101
			: $updating_devices?.[device?.id]?.prog;

	let isActuator = false;
	let authenticate = false;
	$: isGenZ = is_gen_z(device);
	$: isLoqed = is_loqed(device);

	let main_label: { icon: string; value: string; iconColor: string } = {
		icon: '',
		value: '',
		iconColor: '',
	};
	let mode: string = '';

	const isGen2 = is_gen_2(device);
	const isDali = is_dali(device);
	let daliErrors;
	let noControlGearDevices = false;
	const isInputsReader =
		device?.category === 'inputs_reader' ||
		(device?.category === 'module' && device?.mode === 'inputs_reader') ||
		device?.category === 'remote_control';

	beforeUpdate(() => {
		if (
			status?.online &&
			(device.category == 'virtual_device' ||
				'undefined' !== typeof devices_config[device.type] ||
				'undefined' !== typeof devices_config_wave[device.type]) &&
			'undefined' !== typeof device
		) {
			const main_label_filter = statuses.find((label) => {
				return 'undefined' !== typeof label.main;
			});

			main_label = 'undefined' !== typeof main_label_filter ? main_label_filter : main_label;

			mode = get_mode(device, status, settings);
			isActuator = isActuatorHelper(settings, device);

			if (device?.mainActionType === 'param' && !inPreivew) {
				let array: FormattedItemType[] = Object.values(device?.statusLabelParam);
				let mainElement = array.find((el) => el?.m === true);
				let index = statuses.findIndex((el) => el.name === mainElement?.n);

				// Bulbs expose 'color' in color mode and 'color_temp' in white mode.
				// Treat them as the same "current color" parameter for the big slot,
				// so the saved selection keeps rendering after a mode switch.
				if (index < 0 && (mainElement?.n === 'color' || mainElement?.n === 'color_temp')) {
					index = statuses.findIndex((el) => el.name === 'color' || el.name === 'color_temp');
				}

				if (index >= 0) {
					mainParamElement = statuses[index];
				} else {
					mainParamElement = mainElement;
				}
			}
			noControlGearDevices = isDali ? status?.dali?.cg_count === 0 : false;
			daliErrors = isDali ? status?.dali?.errors?.length > 0 : undefined;
		}
	});
</script>

{#if is_gen_2(device) && isLoading && isUpdating}
	{#if isWallDisplay(device?.type) && fwUpdateProgress >= 99}
		<Loader size="m" class="align-self-center" />
	{:else}
		<CircularProgress
			size="s"
			backgroundColor={$showNewLayout ? '--color-2' : '--color-1'}
			progress={fwUpdateProgress}
			type={fwUpdateProgress > 100 ? 'success' : 'primary'}
		/>
	{/if}
{:else if notAuthenticated && isLoading}
	<Icon icon="fal fa-lock" size="s" class="text-color-warning" />
{:else if isLoading}
	<Loader size="m" class="align-self-center" />
{:else if device?.mainActionType === 'param' && mainParamElement?.n !== 'click combinations' && !inPreivew}
	<!-- //CTRITICAL EVENT -->
	{@const hasCriticalEvent = checkIsCriticalEvent(mainParamElement?.value)}
	<LabelV2
		size="m"
		icon={mapIconSolidWeightToLight(mainParamElement?.icon)}
		iconStyle={mainParamElement?.iconStyle}
		value={mainParamElement?.value}
		class="align-self-center max-width-full"
		iconColor={mainParamElement?.iconColor}
		{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
		{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
		{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-base' } : {}}
	/>
{:else if device?.mainActionType === 'param' && mainParamElement?.n === 'click combinations' && !inPreivew}
	<InputsReaderVisualizer
		showLabel
		{device}
		{status}
		{settings}
		{useV2Components}
		isInCard={true}
		deviceButtonV2Props={{
			size: 's',
		}}
		labelV2Props={{
			size: 'm',
		}}
		textStyleTyle={{ styleType: 'tiny' }}
	/>
{:else if status?.online && !isLoading && isVirtualDevice(device?.type) && statuses}
	<!-- Check if the Virtual device is not disabled or not offline -->
	{#if $deviceState?.type > 0 && $deviceState?.type != 14}
		<VirtualDeviceControl
			{device}
			{statuses}
			labelProps={{ size: 'm' }}
			useV2Components={true}
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
			}}
		/>
	{/if}
{:else if status?.online && !isLoading && isPeripheralDevice(device?.type) && statuses}
	<!-- Check if the Peripheral device is not disabled or not offline -->
	{#if $deviceState?.type > 0}
		{#if device.category == 'relay'}
			<ControlOnOffAddon
				{device}
				{status}
				component={device.component}
				class="align-self-center"
				{useV2Components}
			/>
		{:else}
			{@const mainLabel = statuses?.find((i) => i?.mainLabel)}
			{#if mainLabel}
				<LabelV2
					class="align-self-center max-width-full"
					icon={mapIconSolidWeightToLight(mainLabel?.icon) || null}
					iconColor={mainLabel?.iconColor || null}
					value={mainLabel.value || ''}
					size="m"
				/>
			{/if}
		{/if}
	{/if}
{:else if status?.online && !isLoading && isXT1Module(device?.type) && statuses}
	<TemplatesControl
		devBtnsV2Props={{
			deviceButtonV2: { size: 's' },
			doubleDeviceButtonV2: { size: 's' },
			tripleDeviceButtonV2: { size: 's' },
		}}
		{useV2Components}
		{device}
		{statuses}
	/>
{:else if status?.online && !isLoading && device?.type === 'S4SN-0U61X' && isGen2}
	<RadarControl
		useV2Components={true}
		{status}
		labelV2Props={{
			size: 'm',
		}}
	/>
{:else if $deviceState?.type > 0 && $deviceState?.type < 99 && !checkDeviceForceUpdate(device)}
	<Icon {icon} size="s" class={`text-${iconColor} align-self-center`} />
{:else if status?.online && !isLoading && isBluTRV(device.type)}
	<BluTrvControl
		devBtnsV2Props={{
			deviceButtonV2: { size: 's' },
			doubleDeviceButtonV2: { size: 's' },
		}}
		useV2Components={true}
		{device}
		{statuses}
	/>
{:else if status?.online && !isLoading && isPill(device.type)}
	<PillControlStatusSlot
		useV2Components={true}
		{device}
		{statuses}
		{status}
		{type}
		labelV2Props={{
			isVertical: false,
			size: 'm',
		}}
		deviceButtonV2Props={{ size: 's' }}
	/>
{:else if status?.online && !isLoading && (device.category === 'sensor' || device.category === 'gateway')}
	{@const hasCriticalEvent = checkIsCriticalEvent(main_label?.value)}
	<LabelV2
		class="align-self-center max-width-full"
		icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
		value={main_label.value || ''}
		size="m"
		isVertical={isCondensed}
		iconColor={main_label.iconColor}
		{...hasCriticalEvent ? { iconColor: '--color-danger' } : {}}
		{...hasCriticalEvent ? { blinkAnimationStartColor: '--color-danger-20' } : {}}
		{...hasCriticalEvent ? { blinkAnimationEndColor: '--color-base' } : {}}
	/>
{:else if status?.online && !isLoading && isInputsReader}
	<InputsReaderVisualizer
		{useV2Components}
		showLabel
		{device}
		{status}
		{settings}
		isInCard={true}
		deviceButtonV2Props={{
			size: 's',
		}}
		labelV2Props={{
			size: 'm',
		}}
		textStyleTyle={{ styleType: 'tiny' }}
	/>
{:else if status?.online && !isLoading && mode === 'roller'}
	{#if isGen2}
		<ControlDirectionG2
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
				tripleDeviceButtonV2: { size: 's' },
			}}
			useV2Components={true}
			{device}
			{status}
		/>
	{:else if isGenZ}
		<ControlDirectionZ
			{useV2Components}
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
			}}
			{device}
			{status}
			class="align-self-center"
		/>
	{:else}
		<ControlDirection
			{useV2Components}
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
			}}
			{device}
			{status}
			class="align-self-center"
		/>
	{/if}
{:else if status?.online && !isLoading && device.category === 'thermostat'}
	{#if !isWallDisplay(device.type)}
		<ControlTrv
			{useV2Components}
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
			}}
			{device}
			{status}
			{settings}
			class="align-self-center"
		/>
	{:else}
		<ControlWallDisplayThermostat
			useV2Components={true}
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
			}}
			{device}
		/>
	{/if}
{:else if status?.online && !isLoading && ((device.category === 'power_meter' && isGen2) || isNoRelayPlug(device.type))}
	<LabelV2
		class="align-self-center max-width-full"
		icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
		value={main_label.value || ''}
		size="m"
		iconColor={main_label.iconColor}
	/>
{:else if status?.online && !isLoading && device.category === 'pv'}
	<LabelV2
		class="align-self-center max-width-full"
		icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
		value={main_label.value || ''}
		size="m"
		iconColor={main_label.iconColor}
	/>
{:else if status?.online && !isLoading && device.category === 'emeter' && isGen2}
	{@const peripheral = getAddonStatus(device, [], false, true)}
	{#if peripheral.find((i) => i.peripheralType == 'switch')}
		<ControlOnOffAddon
			{device}
			{status}
			component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor?.component}
			class="align-self-center"
			{useV2Components}
			deviceButtonV2Props={{ size: 's' }}
		/>
	{/if}
	<!-- ToDo: maybe display the calculated current consumption for 3 phases -->

	<!-- Adding this additional check isEMWithoutSwitch, because with the inclusion 
	  in Gen4 of EM devices without switch we have a situation, that requires to hide the Turn on/off
	  button, because we have nothing to toggle/turn  -->
	{#if isGen2EM(device.type) && !isEMWithoutSwitch(device.type) && !cardHandlesOnOff}
		<ControlOnOff
			{device}
			{status}
			{settings}
			deviceButtonV2Props={{ size: 's' }}
			{useV2Components}
			class="align-self-center ml-xs"
		/>
	{/if}
	<!-- {/if} -->
{:else if status?.online && isCameraDevice(device)}
	{#if !suppressCameraStatusLabel}
		<CameraStatusLabel {device} {status} {settings} />
	{/if}
{:else if status?.online && settings && !isLoading}
	{#if isGenZ && !cardHandlesOnOff}
		<ControlOnOffZ
			{useV2Components}
			{device}
			{status}
			{settings}
			deviceButtonV2Props={{
				size: 's',
			}}
			class="align-self-center"
		/>
	{:else if isLoqed}
		<ControlLock
			devBtnsV2Props={{
				deviceButtonV2: { size: 's' },
				doubleDeviceButtonV2: { size: 's' },
				tripleDeviceButtonV2: { size: 's' },
			}}
			{useV2Components}
			{device}
		/>
	{:else if !isActuator}
		{#if device.category === 'module' && mode === 'shell'}
			<!-- Module in shell mode has no controls -->
		{:else if mode === 'cct' || (!noControlGearDevices && !daliErrors)}
			{#if !isDiffuser(device.type) && !isNoRelayPlug(device.type)}
				{#if isProSensorAddon(device)}
					{@const peripheral = getAddonStatus(device, [], false, true)}
					{#if peripheral.find((i) => i.peripheralType == 'switch')}
						<ControlOnOffAddon
							{device}
							{status}
							deviceButtonV2Props={{
								size: 's',
							}}
							{useV2Components}
							component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor
								?.component}
							class="mr-xs align-self-center"
						/>
					{/if}
				{/if}
				{#if !(isFanDevice(device?.type) && status?.['fan:0']?.mode === 'auto') && !cardHandlesOnOff}
					<ControlOnOff
						deviceButtonV2Props={{
							size: 's',
						}}
						{device}
						{status}
						{settings}
						{useV2Components}
						class="align-self-center"
					/>
				{/if}
				{#if isFanDevice(device?.type) && status?.['fan:0']?.mode === 'auto'}
					<div
						class="align-self-center ml-xs"
						role="presentation"
						on:pointerdown|stopPropagation
						on:click|stopPropagation
					>
						<ControlVentoraBoost
							{device}
							{status}
							{useV2Components}
							deviceButtonV2Props={{ size: 's' }}
						/>
					</div>
				{/if}
			{:else}
				<ControlOnOffDiffuser
					deviceButtonV2Props={{
						size: 's',
					}}
					{useV2Components}
					{device}
					bind:status
				/>
			{/if}
		{:else}
			<Icon class="align-self-center" icon="fas fa-circle-x" />
		{/if}
	{:else}
		<LabelV2
			class="align-self-center max-width-full"
			icon={mapIconSolidWeightToLight(main_label.icon) || 'fal fa-sensor'}
			value={main_label.value || ''}
			size="m"
			iconColor={main_label.iconColor}
		/>
	{/if}
{/if}

{#if authenticate}
	<AuthenticateDevice {device} bind:showModal={authenticate} />
{/if}
